module.exports = __webpack_public_path__ + "media/assets/icons/ic-link-2001bde0dadd85ab783d29c54275fa76.svg";